const KEY = "locationFilter";

/** Reads and writes the persisted Near value while rejecting incomplete locations. */
export function createNearStorage(storage = window.sessionStorage) {
  function valid(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) {
      return false;
    }
    if (typeof value.zip === "string" && value.zip.trim()) {
      return true;
    }
    function coordinate(number, limit) {
      return (
        (typeof number === "number" || (typeof number === "string" && number.trim() !== "")) &&
        Number.isFinite(Number(number)) &&
        Math.abs(Number(number)) <= limit
      );
    }
    return coordinate(value.lat, 90) && coordinate(value.lng, 180);
  }

  return Object.freeze({
    read() {
      const raw = storage.getItem(KEY);

      if (!raw) {
        return undefined;
      }

      try {
        const value = JSON.parse(raw);

        if (valid(value)) {
          return value;
        }
      } catch {
        // Invalid persisted data is not a usable location.
      }

      storage.removeItem(KEY);
      return undefined;
    },
    write(value) {
      if (valid(value)) {
        storage.setItem(KEY, JSON.stringify(value));
      } else {
        storage.removeItem(KEY);
      }
    },
  });
}
